import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "SpellCheck1"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M4.5 21H9V19.5H4.5V4.5H19.5V12.75H21V4.5C21 3.67157 20.3284 3 19.5 3H4.5C3.67157 3 3 3.67157 3 4.5V19.5C3 20.3284 3.67157 21 4.5 21ZM15.3075 18.4425L17.25 20.385L21.4425 16.1925L22.5 17.25L17.25 22.5L14.25 19.5L15.3075 18.4425ZM15 16.5H16.5L12.75 7.5H11.25L7.5 16.5H9L9.93 14.25H14.0775L15 16.5ZM11.9174 9.435L10.5524 12.75H13.4999L12.1049 9.435H11.9174Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/SpellCheck1.vue"]]);
